module.exports = __webpack_public_path__ + "img/icon-online.7a9111db.svg";